import { Component } from '@angular/core';
import { Router } from '@angular/router';



@Component({
  selector: 'app-footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.scss']
})
export class FooterMenuComponent {
  constructor(private router: Router) {}

  // Condition to check whether the page is home or track appointment 
  isTrackAppointmentPage(): boolean {
    return this.router.url === '/track-appointment';
  }

}
